{
  "decrease": "Diminuir {fieldLabel}",
  "increase": "Aumentar {fieldLabel}",
  "numberField": "Campo de número"
}
